// extracted by mini-css-extract-plugin
export default {"moduleSwitcher-button":"X0r9v","moduleSwitcher":"CR78f","label":"RQ7aB","moduleSwitcher-button--selected":"d34PK","rewardsIconStyle":"UzxfU"};